<template>
    <div class="rest-privat">

        <div v-if="is_load" class="p-3">
            <i class="fal fa-spinner fa-spin"></i>
            Завантаження...
        </div>

        <div v-else>
            <ul class="nav nav-tabs mb-3">
                <li class="nav-item">
                    <a
                        href="#"
                        class="nav-link"
                        :class="{ active: active_tab === 'settings' }"
                        @click.prevent="active_tab = 'settings'"
                    >
                        Налаштування
                    </a>
                </li>

                <li class="nav-item">
                    <a
                        href="#"
                        class="nav-link"
                        :class="{ active: active_tab === 'receivers' }"
                        @click.prevent="active_tab = 'receivers'"
                    >
                        Отримувачі
                    </a>
                </li>
            </ul>

            <!-- SETTINGS -->
            <div v-if="active_tab === 'settings'" class="card">
                <div class="card-header">
                    <strong>Налаштування Privat</strong>
                </div>

                <div class="card-body">
                    <div class="form-group">
                        <label class="form-label">Privat key</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="form.main.privat_key"
                            placeholder="Privat key"
                        >
                    </div>
                </div>
            </div>

            <!-- RECEIVERS -->
            <div v-if="active_tab === 'receivers'" class="card">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <strong>Отримувачі</strong>

                    <button
                        type="button"
                        class="btn btn-sm btn-primary"
                        @click="addReceiver"
                    >
                        <i class="fal fa-plus"></i>
                        Додати
                    </button>
                </div>

                <div class="card-body">

                    <div v-if="form.receivers.length <= 0" class="alert alert-info mb-0">
                        Отримувачі ще не додані
                    </div>

                    <div
                        v-for="(receiver, index) in form.receivers"
                        :key="receiver._key"
                        class="receiver-card border rounded p-3 mb-3"
                    >
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <strong>Отримувач #{{ index + 1 }}</strong>

                            <button
                                type="button"
                                class="btn btn-sm btn-outline-danger"
                                @click="removeReceiver(index)"
                            >
                                <i class="fal fa-trash"></i>
                            </button>
                        </div>

                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="form-label">ОКПО</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="receiver.okpo"
                                        placeholder="ОКПО"
                                    >
                                </div>
                            </div>

                            <div class="col-md-5">
                                <div class="form-group">
                                    <label class="form-label">Назва</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="receiver.name"
                                        placeholder="Назва отримувача"
                                    >
                                </div>
                            </div>

                            <div class="col-md-2">
                                <div class="form-group">
                                    <label class="form-label">Активний</label>

                                    <div class="custom-control custom-switch mt-2">
                                        <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            :id="'privat_receiver_state_' + index"
                                            v-model="receiver.state"
                                        >
                                        <label
                                            class="custom-control-label"
                                            :for="'privat_receiver_state_' + index"
                                        >
                                            {{ receiver.state ? 'Так' : 'Ні' }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mt-3">
                            <receiver-categories
                                :receiver="receiver"
                                :restaurant="rest"
                                :used_ids="getUsedCategoryIds(index)"
                                @duplicate="showDuplicateCategory"
                            />
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import ReceiverCategories from './receiver_categories.vue'

export default {
    name: "rest_privat",

    components: {
        ReceiverCategories
    },

    props: {
        rest: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            is_load: false,
            active_tab: 'settings',

            form: {
                main: {
                    id: 0,
                    privat_key: ''
                },
                receivers: []
            }
        }
    },

    created() {
        this.loadPrivatData()
    },

    methods: {
        loadPrivatData() {
            this.is_load = true

            let url = '/internal/v1/catalog/restaurants/' + parseInt(this.rest.id) + '/privat'

            api.get(url).then(({data}) => {
                this.is_load = false

                if (data.status === "operation_success") {
                    this.$set(this.rest, 'privat', data.data)
                    this.prepareForm(data.data)
                    this.syncToRestaurant()
                }
            }).catch(({response}) => {
                this.is_load = false
                this.showError(response)
            })
        },

        prepareForm(data) {
            let main = data && data.main ? data.main : {}
            let receivers = data && data.receivers ? data.receivers : []

            this.form.main = {
                id: main.id || 0,
                privat_key: main.privat_key || ''
            }

            this.form.receivers = receivers.map((item) => {
                return this.normalizeReceiver(item)
            })
        },

        normalizeReceiver(item) {
            return {
                _key: item.id || this.makeKey(),
                id: item.id || 0,
                okpo: item.okpo || '',
                name: item.name || '',
                state: item.state === undefined ? true : Boolean(item.state),

                // тут храним категории конкретного получателя
                categs: item.categs || item.categories || []
            }
        },

        addReceiver() {
            this.form.receivers.push(this.normalizeReceiver({
                id: 0,
                okpo: '',
                name: '',
                state: true,
                categs: []
            }))

            this.syncToRestaurant()
        },

        removeReceiver(index) {
            this.form.receivers.splice(index, 1)
            this.syncToRestaurant()
        },

        getUsedCategoryIds(currentIndex) {
            let ids = []

            this.form.receivers.forEach((receiver, index) => {
                if (index === currentIndex) {
                    return
                }

                if (!receiver.categs || !Array.isArray(receiver.categs)) {
                    return
                }

                receiver.categs.forEach((id) => {
                    id = parseInt(id)

                    if (id > 0 && !ids.includes(id)) {
                        ids.push(id)
                    }
                })
            })

            return ids
        },

        showDuplicateCategory() {
            EventBus.$emit('show_toast', {
                err: 'Ця категорія вже вибрана в іншого отримувача',
                type: "warning",
                title: "Privat"
            })
        },

        syncToRestaurant() {
            this.$set(this.rest, 'privat', {
                main: this.form.main,
                receivers: this.form.receivers
            })
        },

        getPrivatPayload() {
            return {
                main: {
                    id: this.form.main.id || 0,
                    privat_key: this.form.main.privat_key || ''
                },

                receivers: this.form.receivers.map((item) => {
                    return {
                        id: item.id || 0,
                        okpo: item.okpo || '',
                        name: item.name || '',
                        state: item.state ? 1 : 0,
                        categs: item.categs || []
                    }
                })
            }
        },

        makeKey() {
            return 'receiver_' + Date.now() + '_' + Math.floor(Math.random() * 100000)
        },

        showError(response) {
            EventBus.$emit('show_toast', {
                err: response && response.data ? response.data.message : 'Помилка запиту',
                type: "danger",
                title: response && response.data ? response.data.status : 'error'
            })
        }
    },

    watch: {
        form: {
            deep: true,
            handler() {
                this.syncToRestaurant()
            }
        }
    }
}
</script>

<style scoped>
.receiver-card {
    background: #fff;
}

.nav-link {
    cursor: pointer;
}
</style>
